import type { Organization } from "../../domain/organizations/organization.types";
import {
  getOrganizationCapabilities,
  getVisibleOrganizationSections,
} from "../../domain/organizations/organization.capabilities";

export const ENABLE_SERVICES = true;

export const shouldShowServices = (organization: Organization): boolean =>
  ENABLE_SERVICES &&
  getOrganizationCapabilities(organization).services &&
  getVisibleOrganizationSections(organization).some(({ type }) => type === "services") &&
  Boolean(organization.serviceCatalog?.services.length);
